import { useParams } from "react-router-dom";
import { PathParams, RoutingPath } from "../../../../routes/routing-path";
import { useCallback, useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { printOrderLockActions } from "../../../../slices/lock-order-slice.print";
import { push } from "connected-react-router";

type Props = {
  ignoreInitCheck?: boolean,
}
export const usePrintLock = (props?: Props) => {
  const {
    ignoreInitCheck,
  } = props ?? {};
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const dispatch = useAppDispatch();
  const check = useCallback((orderParam?: Pick<PathParams, 'kijshopCd' | 'shopOrderId'>, noCallback?: () => void) => {
    return new Promise<void>((resolve) => {
      const {
        kijshopCd: reqKijshopCd = kijshopCd,
        shopOrderId: reqShopOrderId = shopOrderId,
      } = orderParam ?? {};
      dispatch(printOrderLockActions.check(reqKijshopCd, reqShopOrderId, {
        yes: () => {
          dispatch(printOrderLockActions.setId(reqShopOrderId));
          resolve();
        },
        no: () => {
          dispatch(printOrderLockActions.setId(''));
          if (noCallback) {
            noCallback();
          } else {
            dispatch(push(RoutingPath.cnv.print({ kijshopCd: reqKijshopCd })));
          }
        },
      }));
    });
  }, [
    dispatch,
    kijshopCd, shopOrderId,
  ]);
  useEffect(() => {
    if (!kijshopCd || !shopOrderId || ignoreInitCheck) return;
    check();
  }, [
    kijshopCd, shopOrderId,
  ]);

  return {
    check,
  }
}